import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'stringDateFormat'
})
export class StringDateFormatPipe implements PipeTransform {
  transform(value: string): string {
    console.log('Date String==>'+value);
    if (!value) return '';
    const [year, month, day] = value.split('-');
    return `${day}/${month}/${year}`;
  }
}